import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { LeadsSelectedColumnsRequestDto } from "../../types";
import { leadsSearchQueryKeys } from "../key-factory/factory";

type HookParams = Pick<UseMutationOptions<void, unknown, LeadsSelectedColumnsRequestDto>, "onSuccess">;

export const useColumnSelectionMutation = ({ onSuccess }: HookParams = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: leadsSearchQueryKeys.columnSelectionMutation(),
        mutationFn(dto: LeadsSelectedColumnsRequestDto) {
            return salesApiService.leadsSearch.saveColumnSelection(dto);
        },
        onSuccess(data, dto, context) {
            onSuccess?.(data, dto, context);

            void queryClient.invalidateQueries({
                queryKey: leadsSearchQueryKeys.columnSelection(),
            });

            void queryClient.resetQueries({
                queryKey: leadsSearchQueryKeys.tableData(),
            });
        },
    });
};
